import React, { ReactNode } from 'react';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { buildPageTitle } from '../../helpers';

import ErrorBoundyTemplate from './ErrorBoundyTemplate';
import messages from './messages';

interface ComponentErrorBoundaryProps {
  home?: string;
  fallback?: ReactNode;
  children: ReactNode;
}

class ComponentErrorBoundary extends React.Component<
  ComponentErrorBoundaryProps,
  { hasError: boolean; errorMessage?: string }
> {
  constructor(props: ComponentErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const errorMessage = error?.message;

    this.setState({ hasError: true, errorMessage });

    logCritical(error, { errorInfo });

    if (!this.props.fallback) {
      document.title = buildPageTitle([messages.title]);
    }
  }

  render() {
    const { children, home, fallback } = this.props;
    const { hasError, errorMessage } = this.state;

    if (hasError && fallback) {
      return fallback;
    }

    if (hasError) {
      return <ErrorBoundyTemplate home={home} errorMessage={errorMessage} />;
    }

    return children;
  }
}

export default ComponentErrorBoundary;
